<template>
    <modal @modal-close="handleClose">

        <div class="modal-wrapper">

            <CloseButton @click="handleClose" />

            <div class="modal-content">
                <div class="item" v-if="draft.checklist_title">
                    <h4>{{ $t("Checklist title") }}</h4>
                    <p>{{ draft.checklist_title }}</p>
                </div>

                <div class="item" v-if="draft.schedule_title">
                    <h4>{{ $t("Schedule title") }}</h4>
                    <p>{{ draft.schedule_title }}</p>
                </div>

                <template v-if="!reachedFreePlanLimit">
                    <div class="item" v-if="draft.description">
                        <h4>{{ $t("Description") }}</h4>
                        <p class="whitespace-pre-line">{{ draft.description }}</p>
                    </div>

                    <div class="item" v-if="draft.site">
                        <h4>{{ $t("Site") }}</h4>
                        <p>{{ draft.sites[draft.site] }}</p>
                    </div>
                </template>

                <reached-inspection-limit-message v-else />

                <offline-inspection-message v-if="displayOfflineWarning" />
            </div>

            <div class="modal-actions-outer-wrapper">
                <div class="modal-actions-inner-wrapper">
                    <button
                        type="button"
                        class="modal-actions-secondary"
                        @click.prevent="handleDeleteDraft"
                        >
                        {{ $t('Delete Draft') }}
                    </button>
                    <button
                        v-if="reachedFreePlanLimit"
                        type="button"
                        class="modal-actions-primary"
                        @click.prevent="handleClose"
                    >
                        {{ $t('Go back') }}
                    </button>
                    <button
                        v-else
                        type="button"
                        class="modal-actions-primary"
                        @click.prevent="handleResumeDraft"
                        >
                        {{ $t('Resume Draft') }}
                    </button>
                </div>
            </div>


        </div>

    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ReachedInspectionLimitMessage from '@mobile/components/ReachedInspectionLimitMessage';
import OfflineInspectionMessage from '@mobile/components/OfflineInspectionMessage';
import CloseButton from '@/components/Modals/CloseButton.vue';
import OnFreePlan from '@mobile/mixins/OnFreePlan';

export default {
    name: 'DraftDetails',

    mixins: [OnFreePlan],

    components: {
        OfflineInspectionMessage,
        ReachedInspectionLimitMessage,
        CloseButton,
    },

    props: {
        draft: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapGetters({
            online: 'connection/online',
        }),

        reachedFreePlanLimit() {
            return this.user.subscription.inspections && this.user.subscription.inspections.limit_reached;
        },

        displayOfflineWarning() {
            return !this.reachedFreePlanLimit && !this.online && this.isOnFreePlan;
        },
    },

    methods: {
        handleClose() {
            this.$emit('close');
        },

        handleDeleteDraft() {
            this.$emit('deleteDraft');
        },

        handleResumeDraft() {
            this.$emit('resumeDraft');
        },

    },


};
</script>
